"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicSnackbars = BasicSnackbars;
exports.TestSnackbars = TestSnackbars;
exports.ButtonClose = exports.ConsecutiveSnackbars = exports.InfoAlert = exports.WarningAlert = exports.SuccessAlert = exports.ErrorAlert = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      maxWidth: 400,
      "& > * + *": {
        marginTop: theme.spacing(2)
      }
    },
    close: {
      padding: theme.spacing(0.5)
    }
  };
});

function BasicSnackbars(props) {
  var messageInfo = props.messageInfo,
      open = props.open,
      handleClose = props.handleClose,
      handleExited = props.handleExited;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], {
    className: classes.root,
    key: messageInfo ? messageInfo.key : undefined,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    open: open,
    autoHideDuration: 4000,
    onClose: handleClose,
    onExited: handleExited
  }, messageInfo ? messageInfo.message : undefined));
}

var ErrorAlert = function ErrorAlert(_ref) {
  var message = _ref.message,
      action = _ref.action;
  return /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    severity: "error",
    action: action
  }, message);
};

exports.ErrorAlert = ErrorAlert;

var SuccessAlert = function SuccessAlert(_ref2) {
  var message = _ref2.message,
      action = _ref2.action;
  return /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    severity: "success",
    action: action
  }, message);
};

exports.SuccessAlert = SuccessAlert;

var WarningAlert = function WarningAlert(_ref3) {
  var message = _ref3.message,
      action = _ref3.action;
  return /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    severity: "warning",
    action: action
  }, message);
};

exports.WarningAlert = WarningAlert;

var InfoAlert = function InfoAlert(_ref4) {
  var message = _ref4.message,
      action = _ref4.action;
  return /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    severity: "info",
    action: action
  }, message);
};

exports.InfoAlert = InfoAlert;

var ConsecutiveSnackbars = function ConsecutiveSnackbars(_ref5) {
  var snackPack = _ref5.snackPack,
      setSnackPack = _ref5.setSnackPack,
      open = _ref5.open,
      setOpen = _ref5.setOpen;

  var _React$useState = _react["default"].useState(undefined),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      messageInfo = _React$useState2[0],
      setMessageInfo = _React$useState2[1];

  _react["default"].useEffect(function () {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo(_objectSpread({}, snackPack[0]));
      setSnackPack(function (prev) {
        return prev.slice(1);
      });
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      // Close an active snack when a new one is added
      setTimeout(function () {
        setOpen(false);
      }, 2000);
    }
  }, [snackPack, messageInfo, open]);

  var handleClose = function handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  var handleExited = function handleExited() {
    setMessageInfo(undefined);
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(BasicSnackbars, {
    messageInfo: messageInfo,
    open: open,
    setOpen: setOpen,
    handleClose: handleClose,
    handleExited: handleExited
  }));
};

exports.ConsecutiveSnackbars = ConsecutiveSnackbars;
var testMessage = "I love candy. I love cookies. I love cupcakes. I love cheesecake. I love chocolate. I love candy. I love cookies. I love cupcakes. I love cheesecake. I love chocolate.";

var ButtonClose = function ButtonClose(_ref6) {
  var onClick = _ref6.onClick;
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "close",
    color: "inherit",
    size: "small",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    fontSize: "inherit"
  }));
};

exports.ButtonClose = ButtonClose;

function TestSnackbars() {
  var _React$useState3 = _react["default"].useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      openSnackbars = _React$useState4[0],
      setOpenSnackbars = _React$useState4[1];

  var _React$useState5 = _react["default"].useState([]),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      snackPack = _React$useState6[0],
      setSnackPack = _React$useState6[1];

  var handleClick = function handleClick(message) {
    return function () {
      setSnackPack(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          message: message,
          key: new Date().getTime()
        }]);
      });
    };
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: handleClick( /*#__PURE__*/_react["default"].createElement(ErrorAlert, {
      message: testMessage,
      action: /*#__PURE__*/_react["default"].createElement(ButtonClose, {
        onClick: function onClick() {
          setOpenSnackbars(false);
        }
      })
    }))
  }, "Show message A"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: handleClick( /*#__PURE__*/_react["default"].createElement(SuccessAlert, {
      message: testMessage
    }))
  }, "Show message B"), /*#__PURE__*/_react["default"].createElement(ConsecutiveSnackbars, {
    snackPack: snackPack,
    setSnackPack: setSnackPack,
    open: openSnackbars,
    setOpen: setOpenSnackbars
  }));
}